import { PayPeriodList } from 'src/types/resources/PayPeriod';
import apiRoutes from 'src/routes/apiRoutes';
import { emptyApi } from 'src/services/emptyApi';

export const payPeriodsApi = emptyApi.injectEndpoints({
  endpoints: builder => ({
    getPayPeriods: builder.query<PayPeriodList, void>({
      query: () => ({
        url: apiRoutes.payPeriods(),
      }),
    }),
  }),
});

export const { useGetPayPeriodsQuery } = payPeriodsApi;
